export default "__VITE_ASSET__R6BSzfwz__"